import { SlugsEnum } from '@/permissions/SlugsEnum'

export default {
  simple: [
    { slug: SlugsEnum.DeveloperPanel, propertyName: 'allowDeveloperPanelAccess' },
    { slug: SlugsEnum.AdminPanel, propertyName: 'allowAdminPanelAccess' },
    {
      slug: SlugsEnum.SideBarDashboardExecute,
      propertyName: 'allowDashboardAccess'
    },
    {
      slug: SlugsEnum.SideBarDataServicesExecute,
      propertyName: 'allowDataServicesAccess'
    },
    {
      slug: SlugsEnum.SideBarStudyManagerExecute,
      propertyName: 'allowStudyManagerAccess'
    },
    { slug: SlugsEnum.GasExportMonth, propertyName: 'allowGasExportMonth' },
    {
      slug: SlugsEnum.DashboardCreateWidget,
      propertyName: 'allowDashboardCreateWidget'
    },
    { slug: SlugsEnum.MapViewPin, propertyName: 'allowMapViewPin' },
    { slug: SlugsEnum.MenuAlertSetup, propertyName: 'allowMenuAlertSetup' },
    { slug: SlugsEnum.MenuCurrentReadings, propertyName: 'allowMenuCurrentReadinngs' },
    { slug: SlugsEnum.MenuHistory, propertyName: 'allowMenuHistory' },
    { slug: SlugsEnum.MenuSharing, propertyName: 'allowMenuSharing' },
    {
      slug: SlugsEnum.CollaboratorsWriteLessThan21,
      propertyName: 'allowCollaboratorsWriteLessThan21'
    },
    {
      slug: SlugsEnum.LoggingIntervalWriteGreaterThan1,
      propertyName: 'allowLoggingIntervalGreaterThan1'
    },
    {
      slug: SlugsEnum.CalibrationWrite,
      propertyName: 'allowUserCalibrationWrite'
    },
    {
      slug: SlugsEnum.LogInAs,
      propertyName: 'allowLogInAs'
    }
  ]
}
